import axios from "axios";
import { httpClient } from "../../lib/http-client";
import type { ProblemDocument, ProblemType } from "./errors";

// pf-developer-network serves the enterprise-api error catalog from S3 under the
// /pfdn gateway prefix: index.json lists every code, {code}.json is one doc.
const BASE = "/pfdn/v1/problems";

interface RawProblemDocument {
  code: string;
  title: string;
  status: number;
  retryable: boolean;
  detail: string;
  partner_action: string;
}

export async function fetchProblemIndex(): Promise<ProblemType[]> {
  const { data } = await httpClient.get<ProblemType[]>(`${BASE}/index.json`);
  return data;
}

export async function fetchProblemDocument(
  code: string,
): Promise<ProblemDocument | null> {
  try {
    const { data } = await httpClient.get<RawProblemDocument>(
      `${BASE}/${encodeURIComponent(code)}.json`,
    );
    return {
      code: data.code,
      title: data.title,
      status: data.status,
      retryable: data.retryable,
      detail: data.detail,
      partnerAction: data.partner_action,
    };
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 404) {
      return null;
    }
    throw error;
  }
}
